<template>
    <v-dialog
        hide-overlay
        :max-width="300"
        :value="show"
        @click:outside="$emit('close')"
        >
        <v-card>
            <v-color-picker
                flat
                hide-mode-switch
                show-swatches
                mode="hexa"
                :value="tempColor"
                :swatches="swatches"
                @update:color="updateColor"
            ></v-color-picker>
            <v-card-actions>
                <primary-button @click="selectAndClose">{{ $t('Select') }}</primary-button>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
import { ref } from "@vue/composition-api";
export default {
    name: "ColorPicker",
    props: {
        show: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            required: false,
            default: '#FFFFFF'
        },
        onSelect: {
            type: Function,
            default: () => null
        },
        swatches: {
            type: Array,
            default: () => [],
            required: false
        }
    },
    setup(props, ctx) {
        const tempColor = ref(props.color)
        const updateColor = (e) => tempColor.value = e.hex

        const selectAndClose = () => {
            props.onSelect(tempColor.value)
            ctx.emit('close')
        }

        return {
            tempColor,
            selectAndClose,
            updateColor
        }
    }
}
</script>

<style scoped lang="scss">

</style>